var emptySelectedSvg='<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.8636 6.29216L12.0703 5.37049C11.9186 5.19549 11.7961 4.86883 11.7961 4.63549V3.64383C11.7961 3.02549 11.2886 2.51799 10.6703 2.51799H9.67863C9.45113 2.51799 9.11863 2.39549 8.94363 2.24383L8.02196 1.45049C7.61946 1.10633 6.96029 1.10633 6.55196 1.45049L5.63613 2.24966C5.46113 2.39549 5.12863 2.51799 4.90113 2.51799H3.89196C3.27363 2.51799 2.76613 3.02549 2.76613 3.64383V4.64133C2.76613 4.86883 2.64363 5.19549 2.49779 5.37049L1.71029 6.29799C1.37196 6.70049 1.37196 7.35383 1.71029 7.75633L2.49779 8.68383C2.64363 8.85883 2.76613 9.18549 2.76613 9.41299V10.4105C2.76613 11.0288 3.27363 11.5363 3.89196 11.5363H4.90113C5.12863 11.5363 5.46113 11.6588 5.63613 11.8105L6.55779 12.6038C6.96029 12.948 7.61946 12.948 8.02779 12.6038L8.94946 11.8105C9.12446 11.6588 9.45113 11.5363 9.68446 11.5363H10.6761C11.2945 11.5363 11.802 11.0288 11.802 10.4105V9.41883C11.802 9.19133 11.9245 8.85883 12.0761 8.68383L12.8695 7.76216C13.2078 7.35966 13.2078 6.69466 12.8636 6.29216ZM9.71363 5.92466L6.89613 8.74216C6.81446 8.82383 6.70363 8.87049 6.58696 8.87049C6.47029 8.87049 6.35946 8.82383 6.27779 8.74216L4.86613 7.33049C4.69696 7.16133 4.69696 6.88133 4.86613 6.71216C5.03529 6.54299 5.31529 6.54299 5.48446 6.71216L6.58696 7.81466L9.09529 5.30633C9.26446 5.13716 9.54446 5.13716 9.71363 5.30633C9.88279 5.47549 9.88279 5.75549 9.71363 5.92466Z" fill="#E6DD0A"></path> </svg>';

var SelectedSvg=`<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path>
                </svg>`;
jQuery(document).ready(function () {

  //get_gifting_configuration();




  const recordedChunks = [];
 
  var audio_record_value=[];
  const handleSuccess = function (stream) {
      let time = 0.00;
      let interval;
      const $activeTab = jQuery('.ct_product .ct_gift_tab.active .tab-content.active');
      const $timerAudio = $activeTab.find('#ct_timer_audio');
      const $stopButton = $activeTab.find('#stop');
      const $startButton = $activeTab.find('#start');
      const $audioElement = $activeTab.find('.record_audio')[0];
      const supportedTypes = [
          "audio/webm",
          "audio/mp4",
          "audio/mpeg",
          "audio/ogg; codecs=vorbis",
          "audio/ogg",
          "audio/3gp2",
          "audio/webm;codecs=vorbis",
          "audio/webm;codecs=opus",
          "audio/3gpp"
      ];
  
      // Determine supported audio type
      const audioType = supportedTypes.find(type => MediaRecorder.isTypeSupported(type)) || "";
  
      if (!audioType) {
          alert("No supported audio type found for recording.");
          return;
      }
  
      try {
          const mediaRecorder = new MediaRecorder(stream, { mimeType: audioType });
  
          // UI Updates
          $stopButton.show();
          $startButton.hide();
          $activeTab.find('.ct_wrap_tips, .ct_tip_lable').hide();
          $activeTab.find('.red-recording-dot, .ct_timer_audio').show();
          $timerAudio.show();
  
          // Start recording
          mediaRecorder.start();
          interval = setInterval(() => {
              time += 0.01;
              $timerAudio.text(time.toFixed(2));
          }, 10);
  
          // Collect recorded data
          mediaRecorder.addEventListener('dataavailable', e => {
              if (e.data.size > 0) recordedChunks.push(e.data);
          });
  
          // Stop recording
          mediaRecorder.addEventListener('stop', () => {
              clearInterval(interval);
              time = 0.00;
              $timerAudio.text("0.00").hide();
              stream.getTracks().forEach(track => track.stop());
  
              const audioBlob = new Blob(recordedChunks, { type: audioType });
              audio_record_value = new Blob(recordedChunks, { type: audioType });
              $audioElement.src = URL.createObjectURL(audioBlob);
              $audioElement.addEventListener('error', e => console.error('Audio error:', e));
  
              // Show recorded audio UI
              $activeTab.find('.ct_wrap_audio').show();
              $activeTab.find('.red-recording-dot').hide();
              $activeTab.find('.ct_audio_recorded').hide();
              //alert("dfdfdf");
              jQuery(".tab_2.ct_tabbing_accord").addClass("ct_fill_active");
              $stopButton.hide();
              $startButton.show();

  
              // CleverTap tracking
              const prodId = __st.rid;
              clevertap.event.push("Gifinting Message Added", {
                  "Message type": "Audio",
                  "Product ID": prodId,
              });
  
              jQuery(".accordion.active .ct_selected_value").html(`
                  Audio added ${SelectedSvg}
              `).show();
              jQuery('.ct_product #ct_gift_save_btn').prop("disabled", false);
          });
  
          $stopButton.on('click', () => mediaRecorder.stop());
      } catch (error) {
          alert(`Recording error: ${error.message}`);
      }
  };
  
  const handleError = (error) => {
      alert(`Microphone access error: ${error.message}`);
  };




  jQuery(document).on("click", ".rb_gift_main_click", function () {
      jQuery(".rb_gift_popup").show();
      jQuery("body").addClass("ct_stop_scroll");
      jQuery(".mm-ajaxcart-close").trigger("click");
      jQuery('.ct_product .ct_design_Gift_Main').show();
      jQuery(".ct_design_Gift_Main").addClass("active");
      get_gifting_configuration();
      
  })



jQuery(document).on('change', '.ct_product .ct_record #audioFileInput', function() {
      
    var files = jQuery(this)[0].files[0];
    jQuery(".ct_product .ct_gift_tab.active  .tab-content.active .ct_wrap_tips").hide();
    jQuery('.ct_product .tab-content.active .ct_wrap_audio').show();
    jQuery('.ct_product .tab-content.active .ct_audio_recorded').hide(); 
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"> <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path> </svg>'

    jQuery(".accordion.active .ct_selected_value").html("Audio added "+svg);
    jQuery(".tab_2.ct_tabbing_accord").addClass("ct_fill_active")
    jQuery(".accordion.active .ct_selected_value").show()
    jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", false);
    jQuery(".ct_product .ct_tip_lable_audio").hide();
    $(".record_audio").attr("src", URL.createObjectURL(files));
        
})

jQuery(document).on('click', '.ct_product .ct_save #ct_gift_save_btn', async function () {
// Retrieve user input
//alert("Please enter")
var cust_name = jQuery(".ct_wrap_contact .ct_msg_name").val();
var cust_number = jQuery(".ct_wrap_contact .ct_msg_number").val();
var msg_type = "";
var msg_val = "";
var msg_id = "";
var flag=true;

// Retrieve selected card and gift
var choose_card = jQuery(".ct_product .ct_card input[name='gift_card']:checked").attr("data-id") || null;
var choose_card_title = jQuery(".ct_product .ct_card input[name='gift_card']:checked").val();

var choose_gift = jQuery(".ct_product .ct_gift_box input[name='gift_box']:checked").attr("data-id") || null;
var choose_gift_title = jQuery(".ct_product .ct_gift_box input[name='gift_box']:checked").val();

// Check message type and retrieve the appropriate value
if(jQuery(".tab_2.ct_tabbing_accord").hasClass("ct_fill_active"))
{
  msg_type = jQuery(".tab-link.active").attr("data-tab");
    if (msg_type == 1) {
        msg_val = jQuery("#ct_gif_msg").val();
    } else if (msg_type == 2 || msg_type == 3) {
       // let fileInput = msg_type == 2 ? "#audioFileInput" : "#videoFileInput, #videoFile";
       let fileInput ="";
       let files_data="";
       if(msg_type == 2){
        if(jQuery("#audioFileInput")[0].files.length > 0)
        {
          fileInput="#audioFileInput";
          files_data = jQuery(fileInput)[0].files[0];
        }
        else
        {
           files_data =audio_record_value;
        }
       }
       else if(msg_type == 3){
          if(jQuery("#videoFileInput")[0].files.length > 0)
          {
            fileInput="#videoFileInput";
            files_data = jQuery(fileInput)[0].files[0];
          }
          else
          {
            fileInput="#videoFile";
            files_data = jQuery(fileInput)[0].files[0];
             
          }
       }
//          fileInput = msg_type == 2 ? "#audioFileInput" : "#videoFileInput";
// console.log(fileInput);
// console.log(jQuery(fileInput)[0].files.length);
//           // If you want to include #videoFile only when necessary, add logic for it:
//           if (jQuery(fileInput)[0].files.length < 1) {
           
//               fileInput = "#videoFile";  // Fallback to #videoFile if #videoFileInput is not found
//           }
//         let files_data = jQuery(fileInput)[0].files;
//         console.log(files_data);
//         console.log(files_data[0]);
        let final_file_data = files_data;
        if (final_file_data != "" && typeof final_file_data != "undefined") {
         // alert("ifff");

            let s_file = await saveMediaToLocalStorage(final_file_data);
            if (s_file) {
                msg_id = s_file.id;
                msg_val = s_file.url;
            }
        }
        else
        {
         // alert("else");
          var get_data = localStorage.getItem("gift_data");
          if(get_data!= null)
          {
            var get_data_obj = JSON.parse(get_data);
            msg_val=get_data_obj.msg_val;
            msg_id=get_data_obj.msg_id
          }
        }
    }
    var r_name=jQuery(".ct_msg_name").val();
    var r_mobile_no=jQuery(".ct_msg_number").val();
    if(r_name != "" && r_mobile_no != "" && msg_val != "")
    {
      flag=false;
    }

}
else{
  if (cust_name !== "" || cust_number !== "" || msg_val !== "") {
    flag = true; // At least one field is filled
  } else {
    flag = false; // All fields are blank
  }
}
if(flag)
{
  if(r_name == ""){  jQuery(".ct_msg_name").addClass("ct_error");}
  if(r_mobile_no == ""){  jQuery(".ct_msg_number").addClass("ct_error"); }
  if(msg_val == ""){ jQuery(".ct_error").text("Please Upload your data"); jQuery(".ct_error").show();}


  if(!jQuery(".tab_2.ct_tabbing_accord .accordion").hasClass("active"))
    {
      jQuery(".tab_2.ct_tabbing_accord .accordion").trigger("click");
    }
 
  return false;
}

  // Generate unique ID
  var uniq_id = Date.now();

  // Prepare gift data object
  var gift_data = {
      "uniq_id": uniq_id,
      "cust_name": cust_name,
      "cust_number": cust_number,
      "msg_type": msg_type,
      "msg_id": msg_id,
      "msg_val": msg_val,
      "choose_card": choose_card,
      "choose_card_title": choose_card_title,
      "choose_box": choose_gift,
      "choose_box_title": choose_gift_title,
  };

  // Save updated gift data to localStorage
  localStorage.setItem("gift_data", JSON.stringify(gift_data));
  jQuery('.ct_product .ct_design_Gift_Main').hide();
  jQuery("body").removeClass("ct_stop_scroll");
  jQuery('.ct_product .ct_cart_design_Gift_Main').hide();
  jQuery('.ct_product .ct_design_Gift_Main').removeClass("active");
          jQuery('.ct_product .ct_cart_design_Gift_Main').removeClass("active");

  var video_src=jQuery(".ct_product .record_video").attr("src")
  var audio_src=jQuery(".ct_product .record_audio").attr("src")
  if(typeof video_src != "undefined" )
  {
      $('.ct_product .record_video').get(0).pause(); 
  }
  if(typeof audio_src != "undefined")
  {
          $('.ct_product .record_audio').get(0).pause();           
  }
  jQuery(".ct_error").hide();
  mmajaxcart.AjaxcartRender();
  setTimeout(function(){
    mmajaxcart.AjaxcartOpen();
  },800)
});

 
  jQuery(document).on('click', '.ct_product #start', function () {
      try {
          navigator.mediaDevices.getUserMedia({ audio: true })
              .then(handleSuccess)
              .catch(handleError);
      } catch (error) {
          alert(`An error occurred: ${error.message}`);
      }
  });

  jQuery(document).on('change', '.ct_product .ct_video_upload #videoFileInput', function () {
      const maxFileSize = 105000000; // 100MB in bytes
      const fileInput = jQuery(this)[0].files[0];
      const videoSize = fileInput.size;
      const fileSizeInMB = formatBytes(videoSize);
      const $ctProduct = jQuery(".ct_product");
      const $activeGiftTab = $ctProduct.find(".ct_gift_tab.active");
      const $activeTabContent = $activeGiftTab.find(".tab-content.active");
      const $accordionActive = jQuery(".accordion.active");
  
      if (videoSize <= maxFileSize) {
          // Hide error messages and update UI
          $activeGiftTab.find(".ct_tip_lable, .ct_wrap_tips").hide();
          jQuery(".ct_err_size").remove();
  
          $ctProduct.find(".ct_video_record_video")
              .addClass("ct_video_uploaded_done")
              .removeClass("ct_video_recorded_done");
          $ctProduct.find(".ct_audio_recorded").hide();
          $ctProduct.find(".ct_return_video_wrap").show();
          $ctProduct.find(".ct_video_play_show").hide();
          $ctProduct.find("#videoRecorded").show();
  
          // Update file preview
          
          const videoSrc = URL.createObjectURL(fileInput);
          if(typeof videoSrc != 'undefined')
          {
              jQuery(".record_video").attr("src", videoSrc);
          }
  
          // Update selected value
          const svgIcon = `
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                  <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path>
              </svg>`;
          $accordionActive.find(".ct_selected_value").html("Video added "+svgIcon ).show();
          $accordionActive.parent().addClass("ct_fill_active");
  
          // Enable save button
          jQuery('.ct_product #ct_gift_save_btn').prop("disabled", false);
  
          // CleverTap event tracking
          const prodId = __st.rid;
          clevertap.event.push("Gifinting Message Added", {
              "Message type": "Video",
              "Product ID": prodId,
          });
      } else {
          // Show error message for large file size
          jQuery(".ct_video_record").after(
              `<span class='ct_err_size' style='color:red'>
                  Your file size is ${fileSizeInMB}, please keep it under 100MB
               </span>`
          );
      }
  });
  function formatBytes(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    jQuery(document).on("click","#ct_gift_cancel_btn",function(){
        jQuery('.ct_product .ct_design_Gift_Main').hide();
      jQuery("body").removeClass("ct_stop_scroll");
        jQuery('.ct_product .ct_cart_design_Gift_Main').hide();
       jQuery('.ct_product .ct_design_Gift_Main').removeClass("active");
              jQuery('.ct_product .ct_cart_design_Gift_Main').removeClass("active");
        
        var video_src=jQuery(".ct_product .record_video").attr("src")
        var audio_src=jQuery(".ct_product .record_audio").attr("src")
        if(typeof video_src != "undefined" )
        {
          $('.ct_product .record_video').get(0).pause(); 
        }
        if(typeof audio_src != "undefined")
        {
             $('.ct_product .record_audio').get(0).pause();           
        }
        jQuery(".ct_error").hide();

    })

    jQuery(document).on("click", ".ct_inner_html.ct_tag_active .ct_in_data", function () {
        const $textbox = jQuery(".tab-content.active #ct_gif_msg");
        const selectText = jQuery(this).text();
        const textboxText = $textbox.val();
    
        const selectedSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path>
        </svg>`;
        
        const notSelectedSvg = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8636 6.29216L12.0703 5.37049C11.9186 5.19549 11.7961 4.86883 11.7961 4.63549V3.64383C11.7961 3.02549 11.2886 2.51799 10.6703 2.51799H9.67863C9.45113 2.51799 9.11863 2.39549 8.94363 2.24383L8.02196 1.45049C7.61946 1.10633 6.96029 1.10633 6.55196 1.45049L5.63613 2.24966C5.46113 2.39549 5.12863 2.51799 4.90113 2.51799H3.89196C3.27363 2.51799 2.76613 3.02549 2.76613 3.64383V4.64133C2.76613 4.86883 2.64363 5.19549 2.49779 5.37049L1.71029 6.29799C1.37196 6.70049 1.37196 7.35383 1.71029 7.75633L2.49779 8.68383C2.64363 8.85883 2.76613 9.18549 2.76613 9.41299V10.4105C2.76613 11.0288 3.27363 11.5363 3.89196 11.5363H4.90113C5.12863 11.5363 5.46113 11.6588 5.63613 11.8105L6.55779 12.6038C6.96029 12.948 7.61946 12.948 8.02779 12.6038L8.94946 11.8105C9.12446 11.6588 9.45113 11.5363 9.68446 11.5363H10.6761C11.2945 11.5363 11.802 11.0288 11.802 10.4105V9.41883C11.802 9.19133 11.9245 8.85883 12.0761 8.68383L12.8695 7.76216C13.2078 7.35966 13.2078 6.69466 12.8636 6.29216ZM9.71363 5.92466L6.89613 8.74216C6.81446 8.82383 6.70363 8.87049 6.58696 8.87049C6.47029 8.87049 6.35946 8.82383 6.27779 8.74216L4.86613 7.33049C4.69696 7.16133 4.69696 6.88133 4.86613 6.71216C5.03529 6.54299 5.31529 6.54299 5.48446 6.71216L6.58696 7.81466L9.09529 5.30633C9.26446 5.13716 9.54446 5.13716 9.71363 5.30633C9.88279 5.47549 9.88279 5.75549 9.71363 5.92466Z" fill="#E6DD0A"></path>
        </svg>`;
    
        // Update textbox value
        const newText = textboxText ? `${textboxText} ${selectText}` : selectText;
        $textbox.val(newText);
    
        // Trim to 400 characters
        const trimText = () => $textbox.val($textbox.val().substring(0, 400));
        let intervalId;
    
        $textbox
            .focus(() => (intervalId = setInterval(trimText, 500)))
            .blur(() => {
                clearInterval(intervalId);
                trimText();
            });
    
        // Set cursor to end of textbox
        const textboxElement = $textbox.get(0);
        textboxElement.selectionStart = textboxElement.selectionEnd = textboxElement.value.length;
    
        $textbox.trigger("keyup").focus();
    
        const $accordion = jQuery(".accordion.active");
        const message = $textbox.val();
    
        if (message.length > 0) {
            $accordion.parent().addClass("ct_fill_active");
            $accordion.find(".ct_selected_value").html("Text added "+selectedSvg).show();
    
            const prodId = __st.rid; // Assuming __st.rid is globally available
            clevertap.event.push("Gifinting Message Added", {
                "Message type": "Note",
                "Product ID": prodId,
            });
        } else {
            $accordion.parent().removeClass("ct_fill_active");
            $accordion.find(".ct_selected_value").html("Not Selected "+notSelectedSvg).show();
        }
    });

    jQuery(document).on('click', '.ct_gift_tab.active .ct_tabbing_accord  .accordion', function() {
     
        jQuery(".ct_gift_tab.active .ct_tabbing_accord .accordion").removeClass("active");

          var check_coach_mark=localStorage.getItem('ct_coach_mark');
          if(!check_coach_mark)
          {
            if(jQuery(this).parent().hasClass("tab_2"))
            {
              jQuery(".ct-cotch-mark").show();
            }
          }
      
        // jQuery(".ct_tabbing_accord .panel_tabing").hide();
        $(this).toggleClass("active");
        var panel = $(this).closest('.ct_tabbing_accord').find(".panel");
        if (panel.hasClass("active")) {
            jQuery(".ct_gift_tab.active .ct_tabbing_accord .panel").removeClass("active");
            jQuery(".ct_gift_tab.active .ct_tabbing_accord .accordion").removeClass("active");
        } else {
            jQuery(".ct_tabbing_accord .panel").removeClass("active");
            jQuery(".ct_tabbing_accord .accordion").removeClass("active");
            panel.addClass("active");
            $(this).closest('.ct_tabbing_accord').find('.accordion').addClass("active")
        }
    });
    
    jQuery(document).on("change", ".ct_card  input[name='gift_card']", function() {
      var $box = $(this);
      if ($box.is(":checked")) {
        // the name of the box is retrieved using the .attr() method
        // as it is assumed and expected to be immutable
        var group = "input:checkbox[name='" + $box.attr("name") + "']";
        // the checked state of the group/box on the other hand will change
        // and the current value is retrieved using .prop() method
        $(group).prop("checked", false);
        $box.prop("checked", true);
        var title = jQuery(this).closest('li').find('.ct_gift_img_title').text();
        var id = jQuery(this).attr('data-id');
        jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').html(title + SelectedSvg );
        jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').show();
         jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", false);
        }  else {
          $box.prop("checked", false)
          jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').html("Not Selected " + emptySelectedSvg );
        }

       

          var prod_id = __st.rid;
                      clevertap.event.push("Gift Box Selected", {
                        "Box Name":title,
                        "Product ID":prod_id,
                        });
        jQuery(".accordion.active").parent().addClass("ct_fill_active")
    });
    jQuery(document).on("change", ".ct_gift_box_li  input[name='gift_box']", function() {

        var $box = $(this);
        if ($box.is(":checked")) {
          // the name of the box is retrieved using the .attr() method
          // as it is assumed and expected to be immutable
          var group = "input:checkbox[name='" + $box.attr("name") + "']";
          // the checked state of the group/box on the other hand will change
          // and the current value is retrieved using .prop() method
          $(group).prop("checked", false);
          $box.prop("checked", true);

          var title = jQuery(this).closest('li').find('.ct_gift_img_title').text()

          jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').html(title + SelectedSvg );
          jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').show();
  
          jQuery(this).closest('.ct_tabbing_accord').addClass("ct_fill_active");
        } else {
          $box.prop("checked", false);
          
        jQuery(this).closest('.ct_tabbing_accord').find('.ct_selected_value').html("Not Selected " + emptySelectedSvg );

        }
       

       var prod_id = __st.rid;
                      clevertap.event.push("Greeting Card Selected", {
                        "Card Name":title,
                        "Product ID":prod_id,
                        });

      

        jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", false);
    });
    jQuery(document).on('click','.ct_gift_delete_btn',function(){
      
      localStorage.removeItem("gift_data");
      mmajaxcart.AjaxcartRender();
    });
    jQuery(document).on('change', '.ct_product #startRecord #videoFile', function() {


      //jQuery(".ct_video_record").after("<span style='color:red'>Please the video maximum size 5MB</span>");
        var video_size=jQuery(this)[0].files[0].size;
         var convert_into_mb=formatBytes(video_size);
      if(video_size <= 105000000)                       
      {
        jQuery(".ct_product .ct_gift_tab.active .ct_tip_lable").hide();
        jQuery(".ct_err_size").remove()
          jQuery(".ct_product .ct_gift_tab.active  .tab-content.active .ct_wrap_tips").hide();
          jQuery('.ct_product  .ct_video_record_video').addClass("ct_video_uploaded_done");
          jQuery('.ct_product  .ct_video_record_video').removeClass("ct_video_recorded_done");
          jQuery('.ct_product .tab-content.active .ct_audio_recorded').hide();
        jQuery('.ct_product .ct_return_video_wrap').show(); 
        jQuery('.ct_product .ct_video_play_show').hide(); 
        
        
        jQuery(".ct_product  #videoRecorded").show();
          var files = jQuery(this)[0].files[0];
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"> <path d="M13.0767 6.28461L12.2834 5.36294C12.1317 5.18794 12.0092 4.86127 12.0092 4.62794V3.63627C12.0092 3.01794 11.5017 2.51044 10.8834 2.51044H9.8917C9.6642 2.51044 9.3317 2.38794 9.1567 2.23627L8.23503 1.44294C7.83253 1.09877 7.17337 1.09877 6.76503 1.44294L5.8492 2.24211C5.6742 2.38794 5.3417 2.51044 5.1142 2.51044H4.10503C3.4867 2.51044 2.9792 3.01794 2.9792 3.63627V4.63377C2.9792 4.86127 2.8567 5.18794 2.71087 5.36294L1.92337 6.29044C1.58503 6.69294 1.58503 7.34627 1.92337 7.74877L2.71087 8.67627C2.8567 8.85127 2.9792 9.17794 2.9792 9.40544V10.4029C2.9792 11.0213 3.4867 11.5288 4.10503 11.5288H5.1142C5.3417 11.5288 5.6742 11.6513 5.8492 11.8029L6.77087 12.5963C7.17337 12.9404 7.83253 12.9404 8.24087 12.5963L9.16253 11.8029C9.33753 11.6513 9.6642 11.5288 9.89753 11.5288H10.8892C11.5075 11.5288 12.015 11.0213 12.015 10.4029V9.41127C12.015 9.18377 12.1375 8.85127 12.2892 8.67627L13.0825 7.75461C13.4209 7.35211 13.4209 6.68711 13.0767 6.28461ZM9.9267 5.91711L7.1092 8.73461C7.02753 8.81627 6.9167 8.86294 6.80003 8.86294C6.68337 8.86294 6.57253 8.81627 6.49087 8.73461L5.0792 7.32294C4.91003 7.15377 4.91003 6.87377 5.0792 6.70461C5.24837 6.53544 5.52837 6.53544 5.69753 6.70461L6.80003 7.80711L9.30837 5.29877C9.47753 5.12961 9.75753 5.12961 9.9267 5.29877C10.0959 5.46794 10.0959 5.74794 9.9267 5.91711Z" fill="#08A217"></path> </svg>'
  
          jQuery(".accordion.active .ct_selected_value").html("Video added"+ svg);
          jQuery(".accordion.active .ct_selected_value").show();
          jQuery(".accordion.active").parent().addClass("ct_fill_active")
        jQuery('.ct_product  #ct_gift_save_btn').prop("disabled", false);
          $(".record_video").attr("src", URL.createObjectURL(files));
          $(".record_video").load();
          
      }
      else
      {        
        jQuery(".ct_video_record").after("<span class='ct_err_size' style='color:red'>Your file size is of "+convert_into_mb+", please keep it under 100MB</span>")
      }
    })
  
})

function get_gifting_configuration() {
    var currentTime = new Date().getTime(); // Current timestamp in milliseconds
    var lastUpdatedTime = localStorage.getItem('gift_configuration_last_updated');
    var get_gift_configure = localStorage.getItem('gift_configuration');

    // Check if the data exists and if it's been more than 3 hours since the last update
    if (get_gift_configure != null && lastUpdatedTime != null && (currentTime - lastUpdatedTime) < 1 * 60 * 60 * 1000) {
        var gift_config_data = jQuery.parseJSON(get_gift_configure);
        gift_html_data_configuration(gift_config_data);
    } else {
        // Fetch fresh data via AJAX
        $.ajax({
            url: `${apiUrl}public/gift-configuration`,
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).done(async function (response) {
            localStorage.setItem('gift_configuration', JSON.stringify(response));
            localStorage.setItem('gift_configuration_last_updated', currentTime);
            gift_html_data_configuration(response);
        }).fail(function () {
            console.error('Failed to fetch gift configuration.');
        });
    }
}

function gift_html_data_configuration(response) {
    if (response.enableGifting) {

        var get_data = localStorage.getItem("gift_data");
        if (get_data != null) {
            var object = JSON.parse(get_data);
            var obj = object;
            jQuery(".gift_success").show();
            jQuery(".gift_video_main").hide();
        }
        else {
            jQuery(".gift_success").hide();
            jQuery(".gift_video_main").show();
        }

        var main_gift_html = "";
        if (response.enableGiftMessage) {
            main_gift_html += gift_add_message(response.addMessageDTO, obj)
        }
        if (response.enableGreetingCard) {
            main_gift_html += gift_choose_card(response.greetingCardImages, obj)
        }
        if (response.enableGiftBox) {
            main_gift_html += gift_choose_box(response.giftBoxImages, obj)
        }
        jQuery(".gift_main_title").text(response.mainTitle);
        jQuery(".gift_main_description").text(response.description);
    } else {
        return false;
    }
    jQuery(".wrap_gift").html(main_gift_html);
}

  function gift_choose_card(card_data, e_card) {

      var card_retrun_html = `<div class="tab_1 ct_tabbing_accord enabled  ${e_card ? (e_card.choose_card_title != null ? `ct_fill_active`:``):``}">
          <div class="accordion">
            <div class="accordion_title">
              <div class="ct_gift_svg">
                <svg width="17" class="accordion_svg_two" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.8096 3.11602L13.5668 2.14497C13.4859 1.78082 13.0449 1.13749 11.9282 1.47736C10.8114 1.81723 4.22039 3.64201 1.06445 4.51192M1.06445 4.51192V23.0227H15.0234C15.3269 22.9418 15.9338 22.5979 15.9338 21.8696C15.9338 21.1413 15.9338 10.5608 15.9338 5.36159C15.954 4.99745 15.8003 4.26915 15.0234 4.26915C14.2466 4.26915 5.39375 4.431 1.06445 4.51192Z" stroke="#242933" stroke-width="0.832361" stroke-linecap="round"></path>
                  <path d="M8.56322 16.3815L8.52933 16.4154L8.49206 16.3815C6.88248 14.921 5.81846 13.9552 5.81846 12.9759C5.81846 12.2982 6.32675 11.7899 7.00447 11.7899C7.52631 11.7899 8.0346 12.1288 8.2142 12.5896H8.84447C9.02407 12.1288 9.53236 11.7899 10.0542 11.7899C10.7319 11.7899 11.2402 12.2982 11.2402 12.9759C11.2402 13.9552 10.1762 14.921 8.56322 16.3815ZM10.0542 11.1122C9.46458 11.1122 8.89869 11.3867 8.52933 11.817C8.15998 11.3867 7.59408 11.1122 7.00447 11.1122C5.96079 11.1122 5.14075 11.9289 5.14075 12.9759C5.14075 14.2534 6.29287 15.3005 8.03799 16.883L8.52933 17.3303L9.02068 16.883C10.7658 15.3005 11.9179 14.2534 11.9179 12.9759C11.9179 11.9289 11.0979 11.1122 10.0542 11.1122Z" fill="#242933"></path>
                </svg>
              </div>
              <span>Add a Card</span>
              <span class="ct_selected_value">
                 ${e_card ? (e_card.choose_card_title != null ? `${e_card.choose_card_title} ${SelectedSvg}` : 
                            `Not Selected ${emptySelectedSvg}</span> `):`Not Selected ${emptySelectedSvg}` }</span>
            </div>
            <div class="accordion_icon">
              <svg class="icon_open" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                <path d="M12.7504 6.27622L12.731 21.121" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <svg class="icon_open_sec" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </div>`
      var card_data_html = `<ul>`;
      jQuery(card_data).each(function (i, c_data) {
          card_data_html += `<li class='ct_gift_box_li'><input data-id='${c_data.id}' type='checkbox' name='gift_card' ${e_card? e_card.choose_card == c_data.id? `checked` :'' :'' }  class='ct_card_img' value='${c_data.title}'>
      <img src="${c_data.image}&width=600" width=200 width=200>
      <div class='ct_gift_img_title'>${c_data.title}</div></li>`;
      })
      card_data_html += `</ul>`;

      card_retrun_html += ` <div class="panel_tabing   panel ct_card">${card_data_html}</div></div>`;

      return card_retrun_html;
  }
  function gift_choose_box(gift_data, e_box) {
      var gift_box_retrun_html = ` <div class="tab_3 ct_tabbing_accord ${e_box ? (e_box.choose_box_title != null ? `ct_fill_active`:``):``}">
                      <div class="accordion">
                        <div class="accordion_title">
                          <div class="ct_gift_svg">
                              <svg class="accordion_svg_three" width="25" height="29" viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.66492 4.05515H24.2873L23.0225 6.27646L24.2873 7.59279L23.0225 8.99139L24.2873 10.5545L23.0225 11.9531L24.2873 13.9276L23.0225 15.4908L24.2873 17.2185L23.0225 18.8639L24.2873 20.427L23.0225 21.7434L24.2873 23.3888L23.0225 25.0342H6.66492" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <rect x="0.786987" y="4.55514" width="7.72728" height="19.979" rx="1.5" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M6.6646 4.05518V3.29993C6.6646 2.14129 5.72534 1.20203 4.5667 1.20203V1.20203C3.40806 1.20203 2.4688 2.14129 2.4688 3.29993V4.05518" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M2.46911 25.0342L2.46911 25.7894C2.46911 26.9481 3.40837 27.8873 4.56701 27.8873V27.8873C5.72565 27.8873 6.66492 26.9481 6.66492 25.7894L6.66492 25.0342" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8.34297 4.39084L0.622688 11.1041" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8.67864 9.92926L0.622688 16.6426" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8.67864 15.6356L0.622688 22.3489" stroke="#50545C" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </div>
                          <span>Add a Gift Box</span>
                          <span class="ct_selected_value">
                          ${e_box ? (e_box.choose_box_title != null ? `${e_box.choose_box_title} ${SelectedSvg}` : 
                            `Not Selected ${emptySelectedSvg} </span> `) : `Not Selected ${emptySelectedSvg}`}</span>
                         
                        </div>
                        <div class="accordion_icon">
                          <svg class="icon_open"  xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                            <path d="M12.7504 6.27622L12.731 21.121" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <svg class="icon_open_sec" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                            <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>`
      var gift_box_data_html = `<ul>`;
      jQuery(gift_data).each(function (i, g_data) {
          gift_box_data_html += `<li class='ct_gift_box_li'><input data-id='${g_data.id}' ${e_box? e_box.choose_box == g_data.id? `checked` :'' :'' }   type='checkbox' name='gift_box' class='ct_gift_box_img' value='${g_data.title}'>
      <img dddd src="${g_data.image}&width=600" width=200 width=200>
      <div class='ct_gift_img_title'>${g_data.title}</div></li>`;
      })
      gift_box_data_html += `</ul>`;

      gift_box_retrun_html += ` <div class="panel_tabing   panel ct_gift_box">${gift_box_data_html}</div></div>`;

      return gift_box_retrun_html;

  }

  function get_message(def_msg,e_msg, addMessageDTO) {
      var msg_data = `
      <div id="tab-1" data-id="1" data-value="message" class="tab-content ${e_msg ? (e_msg.msg_type == 1? 'active' :''):(addMessageDTO.enableVideoMsg != true ? "active": "")} ">
          <textarea id="ct_gif_msg" placeholder="Type your message here..." cols="5" rows="5" maxlength="400">${e_msg ? e_msg.msg_type == "1"? e_msg.msg_val :'':''}</textarea>
          <span class="text_count">0 / 400</span>
          <span class="ct_msg_error" style="display:none">Please enter your message</span>`;
      var defualt_msg = `<ul class="ct_wrap_list">`
      var wrap_default_msg = "";
      jQuery(def_msg).each(function (data, msg_data) {
          var $spanWrappedData = "";
          var ct_active = "";
          if (data == 0) {
              ct_active = "ct_tag_active";
          }
          defualt_msg += `<li class='ct_tag_list ${ct_active}' data-id='data-${data}'>${msg_data.title}</li>`
          $spanWrappedData += `<div class='ct_inner_html ${ct_active}' data-id='data-${data}'>`;

          jQuery(msg_data.msgNotes).each(function (msg_note, data_val) {
              $spanWrappedData += `<div  class='ct_in_data'>${data_val.trim()}</div>`;

          })
          $spanWrappedData += `</div>`;
          //var splitData = commaSeparatedData.split(',');
          // Wrap each message in a <span> tag
          wrap_default_msg += $spanWrappedData;
      })
      defualt_msg += `</ul>`;
      defualt_msg += wrap_default_msg;
      msg_data += defualt_msg;
      msg_data += `</div>`;

      return msg_data;
  }
  function get_audio_message(audio_msg, e_audio, addMessageDTO)
  {
      var audio_html_msg=`<div id="tab-2" data-id="2" data-value="audio" class="tab-content  ${e_audio ?( e_audio.msg_type == "2"? 'active' :''):(addMessageDTO.enableGiftMsg != true ? active: "")}">
                <div class="ct_wrap_tips" ${e_audio ? (e_audio.msg_type == "2" ? 'style="display:none"' :"") : "" } >
                  <div class="ct_tip_title">
                    <span>Notes</span>
                  </div>
                  <div class="ct_tip_desc">
                    <div class="ct_tip_lable ct_max_size">Max. file size 100MB ( upto 45 secs)</div>
                    <span>Use a quiet room. Without wind and noise. Position phone close to sound source.</span>
                  </div>
                </div>
                <div class="ct_record">
                  <div class="ct_record_sec">
                    <div class="ct_record_inner"></div>
                  </div>
                  <div class="ct_wrap_audio" ${e_audio ? (e_audio.msg_type == "2" ? '' :'style="display:none"') : 'style="display:none"' }  bis_skin_checked=" 1">
                    <audio controls="" class="record_audio" src="${e_audio ?(e_audio.msg_type == 2 ? e_audio.msg_val :""): "" }"   playsinline=""></audio>
                    <div class="ct_wrap_return">
                      <button class="ct_again_audio gift_record_again">Record Again</button>
                      <button class="ct_again_audio gift_delete_audio">Delete Audio</button>
                    </div>
                  </div>
                </div>
                <div class="ct_audio_sec ct_audio_recorded" ${e_audio ? (e_audio.msg_type == "2" ? 'style="display:none"' :"") : ""}>
                  <div class="aud_one">
                    <div class="red-recording-dot_count" id="ct_timer_audio">00.00</div>
                    <div class="red-recording-dot"></div>
                  </div>
                  <div class="aud_two">
                    <div id="start" class="aud_two_start audio_record_icon">
                      <img class="ct_audio_icon" src="https://cdn.shopify.com/s/files/1/0796/1959/files/Audio-icon.png?v=1721124032">
                    </div>
                    <div id="stop" class="aud_two_stop">
                      <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_134_661)">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.61816 8.0874C7.61816 7.82219 7.72352 7.56783 7.91106 7.3803C8.09859 7.19276 8.35295 7.0874 8.61816 7.0874H14.6182C14.8834 7.0874 15.1377 7.19276 15.3253 7.3803C15.5128 7.56783 15.6182 7.82219 15.6182 8.0874V14.0874C15.6182 14.3526 15.5128 14.607 15.3253 14.7945C15.1377 14.982 14.8834 15.0874 14.6182 15.0874H8.61816C8.35295 15.0874 8.09859 14.982 7.91106 14.7945C7.72352 14.607 7.61816 14.3526 7.61816 14.0874V8.0874Z" fill="#D60227"></path>
                        </g>
                        <path d="M0.618164 11.0874C0.618164 5.0124 5.54316 0.0874023 11.6182 0.0874023C17.6932 0.0874023 22.6182 5.0124 22.6182 11.0874C22.6182 17.1624 17.6932 22.0874 11.6182 22.0874C5.54316 22.0874 0.618164 17.1624 0.618164 11.0874ZM11.6182 1.5874C9.09861 1.5874 6.68225 2.58829 4.90065 4.36989C3.11905 6.15148 2.11816 8.56785 2.11816 11.0874C2.11816 13.607 3.11905 16.0233 4.90065 17.8049C6.68225 19.5865 9.09861 20.5874 11.6182 20.5874C14.1377 20.5874 16.5541 19.5865 18.3357 17.8049C20.1173 16.0233 21.1182 13.607 21.1182 11.0874C21.1182 8.56785 20.1173 6.15148 18.3357 4.36989C16.5541 2.58829 14.1377 1.5874 11.6182 1.5874Z" fill="#D60227"></path>
                        <defs>
                          <clipPath id="clip0_134_661">
                            <rect width="12" height="12" fill="white" transform="translate(5.61816 5.0874)"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div class="aud_three ct_record_upload">                      
                    <div class="ct_record">
                      <input type="file" id="audioFileInput" accept="audio/*">
                    </div>
                    <div class="aud_three_text">Upload Audio</div>
                  </div>
                </div>
                <div class="ct_tip_lable ct_tip_lable_audio" ${e_audio ? (e_audio.msg_type == "2" ? 'style="display:none"' :"") : "" }>Start Recording</div>
              </div>`

              return audio_html_msg;
  }
  function get_video_message(video_msg, e_video, addMessageDTO) {
    const msgType = e_video?.msg_type || "";
    const isMsgType3 = msgType === "3";
    const videoSrc = isMsgType3 ? e_video.msg_val : "";

    return `
        <div id="tab-3" data-id="3" data-value="video" class="tab-content ${msgType ? (isMsgType3 ? 'active' : '') : 'active'}">
            <div class="ct_wrap_tips" ${isMsgType3 ? 'style="display:none"' : ''}>
                <div class="ct_tip_title">
                    <span>Notes</span>
                </div>
                <div class="ct_tip_desc">
                    <div class="ct_tip_lable ct_max_size">Max. file size 100MB (upto 45 secs)</div>
                    <span>Use a quiet room. Without wind and noise. Position phone close to sound source.</span>
                </div>
            </div>
            <div class="ct_video_record">
                <div class="ct_record_sec"></div>
                <div class="ct_video_record_video ${isMsgType3 ? 'ct_video_uploaded_done' : ''}">
                    <div class="Video_box_ct">
                        <video class="record_video" controls src="${videoSrc}" playsinline id="videoRecorded"></video>
                        <video id="video" width="400" height="300" autoplay></video>
                    </div>
                    <div class="ct_audio_sec ct_audio_recorded" ${isMsgType3 ? 'style="display:none"' : ''}>
                        <div class="aud_one">
                            <div class="red-recording-dot_count" id="ct_timer">00.00</div>
                            <div class="red-recording-dot"></div>
                        </div>
                        <div class="aud_two">
                            <div id="startRecord" class="aud_two_start video_record_icon">
                                <input type="file" id="videoFile" accept="video/*" capture="camcorder">
                                <img class="ct_video_icon" src="https://cdn.shopify.com/s/files/1/0796/1959/files/Video-icon.png?v=1721124032">
                            </div>
                            <div id="stopRecord" class="aud_two_stop">
                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_134_661)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.61816 8.0874C7.61816 7.82219 7.72352 7.56783 7.91106 7.3803C8.09859 7.19276 8.35295 7.0874 8.61816 7.0874H14.6182C14.8834 7.0874 15.1377 7.19276 15.3253 7.3803C15.5128 7.56783 15.6182 7.82219 15.6182 8.0874V14.0874C15.6182 14.3526 15.5128 14.607 15.3253 14.7945C15.1377 14.982 14.8834 15.0874 14.6182 15.0874H8.61816C8.35295 15.0874 8.09859 14.982 7.91106 14.7945C7.72352 14.607 7.61816 14.3526 7.61816 14.0874V8.0874Z" fill="#D60227"></path>
                                    </g>
                                    <path d="M0.618164 11.0874C0.618164 5.0124 5.54316 0.0874023 11.6182 0.0874023C17.6932 0.0874023 22.6182 5.0124 22.6182 11.0874C22.6182 17.1624 17.6932 22.0874 11.6182 22.0874C5.54316 22.0874 0.618164 17.1624 0.618164 11.0874ZM11.6182 1.5874C9.09861 1.5874 6.68225 2.58829 4.90065 4.36989C3.11905 6.15148 2.11816 8.56785 2.11816 11.0874C2.11816 13.607 3.11905 16.0233 4.90065 17.8049C6.68225 19.5865 9.09861 20.5874 11.6182 20.5874C14.1377 20.5874 16.5541 19.5865 18.3357 17.8049C20.1173 16.0233 21.1182 13.607 21.1182 11.0874C21.1182 8.56785 20.1173 6.15148 18.3357 4.36989C16.5541 2.58829 14.1377 1.5874 11.6182 1.5874Z" fill="#D60227"></path>
                                    <defs>
                                        <clipPath id="clip0_134_661">
                                            <rect width="12" height="12" fill="white" transform="translate(5.61816 5.0874)"></rect>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div class="aud_three ct_record_upload">
                            <div class="ct_record ct_video_upload">
                                <input type="file" id="videoFileInput" accept="video/*">
                            </div>
                            <div class="aud_three_text">Upload Video</div>
                        </div>
                    </div>
                    <div class="ct_tip_lable ct_tip_lable_video" ${isMsgType3 ? 'style="display:none"' : ''}>Start Recording</div>
                    <div class="ct_return_video_wrap" ${isMsgType3 ? '' : 'style="display:none"'}>
                        <button class="ct_return_btn gift_shoot_again">Shoot Again</button>
                        <button class="ct_return_btn gift_delete_video">Delete Video</button>
                    </div>
                </div>
            </div>
        </div>
    `;
}

  function gift_add_message(message_data ,e_msg) {
    var wrap_msg = "", wrap_audio_msg = "", wrap_video_msg = ""; 
    var tab_audio_li = "", tab_video_li = "", tab_msg_li = "";
    var active_class_flag=true;

    if(message_data.enableVideoMsg)
      {
        tab_video_li=`<li class="tab-link ${e_msg? (e_msg.msg_type != "" ? (e_msg.msg_type == 3 ? 'active' :''):'active') : "active"}" data-tab="3">
                  <svg class="ct-video-svg" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <path d="M15.892 11.1319L20.6047 8.77612C20.7624 8.69729 20.9377 8.66007 21.1139 8.66801C21.2901 8.67594 21.4613 8.72877 21.6114 8.82146C21.7614 8.91416 21.8853 9.04366 21.9712 9.19768C22.0572 9.35169 22.1023 9.52511 22.1024 9.70147V16.7027C22.1023 16.879 22.0572 17.0524 21.9712 17.2065C21.8853 17.3605 21.7614 17.49 21.6114 17.5827C21.4613 17.6754 21.2901 17.7282 21.1139 17.7361C20.9377 17.7441 20.7624 17.7068 20.6047 17.628L15.892 15.2722V11.1319ZM3.47122 9.0618C3.47122 8.51277 3.68932 7.98622 4.07755 7.598C4.46577 7.20977 4.99232 6.99167 5.54135 6.99167H13.8219C14.3709 6.99167 14.8975 7.20977 15.2857 7.598C15.6739 7.98622 15.892 8.51277 15.892 9.0618V17.3423C15.892 17.8914 15.6739 18.4179 15.2857 18.8061C14.8975 19.1944 14.3709 19.4125 13.8219 19.4125H5.54135C4.99232 19.4125 4.46577 19.1944 4.07755 18.8061C3.68932 18.4179 3.47122 17.8914 3.47122 17.3423V9.0618Z" stroke="#242933" stroke-width="1.91089" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>Video</span>
                </li>`;
        wrap_video_msg = get_video_message(message_data.defaultNoteMsgList, e_msg, message_data);
        active_class_flag=false;

    }
    if(message_data.enableGiftMsg)
    {
      tab_msg_li=`  <li class="tab-link ${e_msg ? (e_msg.msg_type != "" ? (e_msg.msg_type == 1 ? 'active' :''):(message_data.enableVideoMsg != true ? "active":"")) : (message_data.enableVideoMsg != true ? "active":"")}" data-tab="1">
                  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.75623 9.97741C9.75623 9.7636 9.84116 9.55855 9.99235 9.40737C10.1435 9.25619 10.3486 9.17125 10.5624 9.17125H17.0116C17.2254 9.17125 17.4305 9.25619 17.5817 9.40737C17.7329 9.55855 17.8178 9.7636 17.8178 9.97741C17.8178 10.1912 17.7329 10.3963 17.5817 10.5474C17.4305 10.6986 17.2254 10.7836 17.0116 10.7836H10.5624C10.3486 10.7836 10.1435 10.6986 9.99235 10.5474C9.84116 10.3963 9.75623 10.1912 9.75623 9.97741ZM10.5624 14.0082H17.0116C17.2254 14.0082 17.4305 13.9233 17.5817 13.7721C17.7329 13.6209 17.8178 13.4158 17.8178 13.202C17.8178 12.9882 17.7329 12.7832 17.5817 12.632C17.4305 12.4808 17.2254 12.3959 17.0116 12.3959H10.5624C10.3486 12.3959 10.1435 12.4808 9.99235 12.632C9.84116 12.7832 9.75623 12.9882 9.75623 13.202C9.75623 13.4158 9.84116 13.6209 9.99235 13.7721C10.1435 13.9233 10.3486 14.0082 10.5624 14.0082ZM13.787 15.6205H10.5624C10.3486 15.6205 10.1435 15.7054 9.99235 15.8566C9.84116 16.0078 9.75623 16.2129 9.75623 16.4267C9.75623 16.6405 9.84116 16.8455 9.99235 16.9967C10.1435 17.1479 10.3486 17.2328 10.5624 17.2328H13.787C14.0008 17.2328 14.2059 17.1479 14.3571 16.9967C14.5082 16.8455 14.5932 16.6405 14.5932 16.4267C14.5932 16.2129 14.5082 16.0078 14.3571 15.8566C14.2059 15.7054 14.0008 15.6205 13.787 15.6205ZM23.4609 5.14047V16.0931C23.4616 16.3049 23.4201 16.5148 23.339 16.7104C23.2579 16.9061 23.1387 17.0836 22.9883 17.2328L17.8178 22.4033C17.6686 22.5537 17.491 22.6729 17.2954 22.754C17.0997 22.8352 16.8899 22.8766 16.6781 22.8759H5.72544C5.29783 22.8759 4.88773 22.7061 4.58536 22.4037C4.283 22.1013 4.11313 21.6912 4.11313 21.2636V5.14047C4.11313 4.71285 4.283 4.30276 4.58536 4.00039C4.88773 3.69802 5.29783 3.52815 5.72544 3.52815H21.8486C22.2762 3.52815 22.6863 3.69802 22.9887 4.00039C23.291 4.30276 23.4609 4.71285 23.4609 5.14047ZM5.72544 21.2636H16.2055V16.4267C16.2055 16.2129 16.2904 16.0078 16.4416 15.8566C16.5928 15.7054 16.7978 15.6205 17.0116 15.6205H21.8486V5.14047H5.72544V21.2636ZM17.8178 17.2328V20.1249L20.7089 17.2328H17.8178Z" fill="#50545C"></path>
                  </svg>
                  <span>Note</span>
                </li>`;
      wrap_msg = get_message(message_data.defaultNoteMsgList, e_msg, message_data);
      active_class_flag=false;
    }   
    if(message_data.enableAudioMsg)
      {
        tab_audio_li=` <li class="tab-link ${e_msg ? (e_msg.msg_type != "" ? (e_msg.msg_type == 2 ? 'active' :''):(message_data.enableGiftMsg != true ? "active" :"" )) : (message_data.enableGiftMsg != true ? "active" :"" )}" data-tab="2">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.2926 11.795C21.2926 11.6883 21.2052 11.6009 21.0985 11.6009H19.6429C19.5362 11.6009 19.4489 11.6883 19.4489 11.795C19.4489 15.1986 16.6906 17.9569 13.287 17.9569C9.8834 17.9569 7.12511 15.1986 7.12511 11.795C7.12511 11.6883 7.03778 11.6009 6.93104 11.6009H5.47548C5.36874 11.6009 5.2814 11.6883 5.2814 11.795C5.2814 15.8876 8.35264 19.2645 12.3166 19.7424V22.2265H8.79173C8.45938 22.2265 8.19253 22.5734 8.19253 23.0028V23.8762C8.19253 23.9829 8.26045 24.0702 8.34293 24.0702H18.231C18.3135 24.0702 18.3815 23.9829 18.3815 23.8762V23.0028C18.3815 22.5734 18.1146 22.2265 17.7822 22.2265H14.1603V19.7545C18.1704 19.3178 21.2926 15.9215 21.2926 11.795ZM13.287 15.9191C15.5649 15.9191 17.4111 14.0948 17.4111 11.8435V6.40942C17.4111 4.15815 15.5649 2.33385 13.287 2.33385C11.009 2.33385 9.1629 4.15815 9.1629 6.40942V11.8435C9.1629 14.0948 11.009 15.9191 13.287 15.9191ZM11.0066 6.40942C11.0066 5.1819 12.0231 4.17756 13.287 4.17756C14.5509 4.17756 15.5674 5.1819 15.5674 6.40942V11.8435C15.5674 13.071 14.5509 14.0754 13.287 14.0754C12.0231 14.0754 11.0066 13.071 11.0066 11.8435V6.40942Z" fill="#D60227"></path>
                </svg>
                <span>Audio</span>
              </li>`
        wrap_audio_msg = get_audio_message(message_data.defaultNoteMsgList, e_msg, message_data);
    }
   
 


      var msg_data = `<div class="tab_2 ct_tabbing_accord enabled   ${e_msg?(e_msg.msg_type != "" ? 'ct_fill_active' : ''):'' } ">
        <div class="accordion">
          <div class="accordion_title">
            <div class="ct_gift_svg">
              <svg width="25" height="26" class="accordion_svg_two" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.91634 10.452H16.1663M7.91634 14.1187H16.1663M7.91634 17.7854H12.4997M21.6663 13.202C21.6663 18.2648 17.5624 22.3687 12.4997 22.3687H3.33301V13.202C3.33301 8.13929 7.43692 4.03537 12.4997 4.03537C17.5624 4.03537 21.6663 8.13929 21.6663 13.202Z" stroke="#242933" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <span>Add a Message</span>
            <span class="ct_selected_value">
        
            ${e_msg? e_msg.msg_type == "1" ? 'Text added' : e_msg.msg_type == "2" ?  'Audio added' : e_msg.msg_type == "3"? 'Video added'  : '' : '' }
             ${e_msg? e_msg.msg_type != ""? `${SelectedSvg}`:`Not Selected ${emptySelectedSvg}</span>`: `Not Selected ${emptySelectedSvg}</span>`}
               </span>
          </div>
          <div class="accordion_icon">
            <svg class="icon_open" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
              <path d="M12.7504 6.27622L12.731 21.121" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <svg class="icon_open_sec" xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
              <path d="M5.2959 13.6986H20.1407" stroke="black" stroke-width="3.18103" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </div>
        <div class="panel_tabing  panel tabing">
          <div class="wrapper">
            <div class="ct_wrap_contact">
                            <div class="ct_contact_wrap">
                              <input onkeydown="return /[a-z ]/i.test(event.key)" type="text" placeholder="Receiver\'s Name " name="name" class="ct_msg_name" ${e_msg ? `value="${e_msg.cust_name}"` : ''}>
                              <button style="display:none" class="ct_contact_btn" onclick="openContactPicker()"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none"> <g opacity="0.7"> <path d="M14.9251 11.813H14.925C14.925 10.8705 14.1094 10.1064 13.1032 10.1064H11.1231C10.1169 10.1064 9.30127 10.8705 9.30127 11.813V13.5878H14.9251V11.813Z" fill="#D60227"/> <path d="M12.1133 9.64033C13.0989 9.64033 13.898 8.89187 13.898 7.9686C13.898 7.04533 13.0989 6.29688 12.1133 6.29688C11.1276 6.29688 10.3286 7.04533 10.3286 7.9686C10.3286 8.89187 11.1276 9.64033 12.1133 9.64033Z" fill="#D60227"/> <path d="M19.1725 0H5.05391C4.48614 0 4.02583 0.431174 4.02583 0.962973V3.39302C3.50631 3.44138 3.10059 3.85177 3.10059 4.35111C3.10059 4.85045 3.50631 5.26088 4.02583 5.3092V7.1589C3.50631 7.20725 3.10059 7.61765 3.10059 8.11699C3.10059 8.61632 3.50631 9.02675 4.02583 9.07507V10.9248C3.50631 10.9731 3.10059 11.3835 3.10059 11.8829C3.10059 12.3822 3.50631 12.7926 4.02583 12.8409V14.6906C3.50631 14.739 3.10059 15.1494 3.10059 15.6487C3.10059 16.1481 3.50631 16.5585 4.02583 16.6068V19.0369C4.02583 19.5687 4.48614 19.9998 5.05387 19.9998H19.1724C19.7402 19.9998 20.2005 19.5687 20.2005 19.0369V0.962973C20.2005 0.431174 19.7402 0 19.1725 0ZM18.1444 18.0741H6.08195V16.607C6.60147 16.5587 7.00719 16.1483 7.00719 15.6489C7.00719 15.1496 6.60147 14.7392 6.08195 14.6908V12.8411C6.60147 12.7928 7.00719 12.3824 7.00719 11.8831C7.00719 11.3837 6.60147 10.9733 6.08195 10.925V9.07527C6.60147 9.02691 7.00719 8.61652 7.00719 8.11718C7.00719 7.61784 6.60147 7.20741 6.08195 7.15909V5.30932C6.60147 5.26096 7.00719 4.85057 7.00719 4.35123C7.00719 3.85189 6.60147 3.44146 6.08195 3.39314V1.92598H18.1444V18.0741Z" fill="#D60227"/> </g> </svg></button>
                            </div>
                              <span style="display:none" class="ct_name_error">Please enter the receiver name</span>
                              <input maxlength="10" pattern="[0-9]*" type="tel" placeholder="Receiver\'s Mobile No." name="phone" class="ct_msg_number"  ${e_msg ?`value="${e_msg.cust_number}"`:''}>
                              <span style="display:none" class="ct_no_error">Please enter the valid mobile number</span>
                          </div>
            <div class="tab-wrapper">
              <ul class="tabs">
                
              ${tab_video_li}
              ${tab_msg_li}
              ${tab_audio_li}
               
              </ul>
            </div>
            <div class="content-wrapper">
            ${wrap_msg}
            ${wrap_audio_msg}
            ${wrap_video_msg}                
              
            </div>
            <div style="clear:both"></div>
          </div>
        </div>
      </div>`;
      return msg_data;
  }
// Upload media to the server
async function saveMediaToLocalStorage(files_data) {
    var form = new FormData();
    form.append("file", files_data);
    form.append("source", "GIFT");

    try {
        var response = await $.ajax({
            "url": "https://middleware.technoboost.in/gift/upload-attachment",
            "type": "POST",
            "data": form,
            processData: false, // important
            contentType: false, // important
        });
        return response;
    } catch (error) {
        console.error("Error uploading media:", error);
        return null;
    }
}

// Fetch media message data
async function get_msg_data(media_id) {
    try {
        var response = await $.ajax({
            "url": `https://middleware.technoboost.in/gift/preview/${media_id}`,
            "method": "GET",
            "timeout": 0,
        });
        return response;
    } catch (error) {
        console.error("Error fetching message data:", error);
        return null;
    }
}